import { EntityParams } from "../Domain/EntityParams";
import { EntityPersonal } from "../Domain/EntityPersonal";
import { RepositoryMain } from "../Domain/RepositoryMain";

export class UseCaseSelectPersonal {
    private repository: RepositoryMain;

    constructor(_repository: RepositoryMain) {
        this.repository = _repository;
    }

    public async exec(params: EntityParams): Promise<Array<EntityPersonal>> {
        return await this._exec(params);
    }

    private async _exec(params: EntityParams): Promise<Array<EntityPersonal>> {
        return await this.repository.selectPersonal(params);
    }
}